const Header = ({group}) => {
    return (
        <header className="text-center" style={{margin: '2em'}}>
            <h1>Honors Carolina Resume App</h1>
            <h4><em>{group}</em></h4>
        </header>
    )
}
export default Header